import styled from 'styled-components';
import StyleGuide from 'src/style-guide';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;
const { EMAIL_STATES } = constants.jobShare;

export const JobShareLoadingModalContainer = styled(StyleGuide.Modal)`
  @media ${DEVICE.MOBILE_PORTRAIT} {
    max-width: calc(100vw - 48px);
  }
`;

export const JobShareModalContainer = styled(StyleGuide.Modal)`
  @media ${DEVICE.MOBILE_PORTRAIT} {
    max-height: 100% !important; /* must set important to override styleguide due to styled-components v2 https://github.com/styled-components/styled-components/issues/2095 */
    top: 0;
    transform: none;
    left: 0;
    height: 100%;
  }

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    top: 44%;
    height: 75%;
    padding-bottom: 0;
  }
`;

export const IconContainerStyles = styled.div`
  display: inline-block;
  cursor: pointer;
  margin-left: ${({ marginLeft }) => marginLeft}px;

  svg {
    height: ${({ size }) => size}px;
    width: ${({ size }) => size}px;
  }
`;

export const ModalContent = styled.div`
  padding-bottom: ${({ isIOS, theme }) =>
    isIOS ? 'none;' : theme.utils.pxToRem(50)}rem;
`;

export const SocialMediaShareContainer = styled.div`
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  align-items: center;
  height: 50px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightGrayThree};
  border-radius: 0 0 3px 3px;

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    position: sticky;
    min-height: 50px;
    width: calc(100% + 60px);
    transform: translateX(-30px);
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: max(env(safe-area-inset-top), 8px);
  right: 8px;
  padding: 10px;
  cursor: pointer;

  svg {
    transform: rotate(45deg);
    width: 24px;
    height: 24px;

    path {
      fill: ${({ theme }) => theme.colors.steel};
    }
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.colors.defaultActionBlue};
    }
  }
`;

export const Header = styled.div`
  margin: 0 auto 24px auto;
  max-width: 90%;
  ${({ theme }) => theme.mixins.textEllipsis()}
  ${({ theme }) => theme.mixins.font('bold', 24)}
`;

export const CopyLink = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.div`
  margin-bottom: 8px;
  ${({ theme }) => theme.mixins.fontWeights.bold}
`;

export const CopyLinkTextInput = styled.input`
  &&& {
    /* this is needed to override styles from foundation */
    display: inline-block;
    margin-right: 12px;
    max-width: calc(100% - 83px);
    background-color: ${({ theme }) => theme.colors.white};

    @media ${DEVICE.MOBILE_PORTRAIT} {
      max-width: 100%;
    }
  }
`;

export const CopyButton = styled.button`
  display: inline-block;
  height: 37px;
  padding: 0 14px;
  line-height: 37px;
  background-color: ${({ theme }) => theme.colors.defaultActionBlue};

  @media ${DEVICE.MOBILE_PORTRAIT} {
    width: 100%;
  }
`;

export const ShareWithAFriendContainer = styled.div``;

export const EmailAddressInput = styled.input``;

export const EmailMessageTextArea = styled.textarea``;

export const SendButton = styled.button`
  &&& {
    /* this is needed to override styles from foundation */
    width: 100%;
    background-color: ${({ emailState, theme }) => {
      switch (emailState) {
        case EMAIL_STATES.notReadyToSend.id:
          return theme.colors.disabledGray;
        case EMAIL_STATES.readyToSend.id:
          return theme.colors.defaultActionBlue;
        case EMAIL_STATES.sending.id:
          return theme.colors.processingYellow;
        case EMAIL_STATES.sent.id:
          return theme.colors.brightGreen;
        default:
          return theme.colors.disabledGray;
      }
    }};
  }
`;
